<div class="cropper-modal">
  <div class="cropper-modal__header">
    <app-text
      [textSize]="TextSizes.h1Header"
      [textType]="TextType.base"
      text="Фотография"
    ></app-text>

    <div (click)="closed()" class="cropper-modal__close">
      <img [src]="'assets/images/icons-svg/close.svg'" />
    </div>
  </div>

  <div class="cropper-modal__caption">
    <app-text
      [textSize]="TextSizes.h5Post"
      [textType]="TextType.base"
      text="Выберите нужную вам область изображения"
    ></app-text>
  </div>

  <div class="cropper__container">
    <image-cropper
      class="cropper"
      [imageFile]="imageToCrop"
      [format]="imageFormat"
      [aspectRatio]="aspectRatio"
      [canvasRotation]="canvasRotation"
      [maintainAspectRatio]="!!aspectRatio"
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>

    <app-spinner [color]="SpinnerColor.blue" [isLoading]="isLoading"></app-spinner>

    @if (!isLoading) {
      <div class="cropper__rotate">
        <button class="btn-rotate ion-activatable" (click)="rotate('left')">
          <img [src]="IconRotate" />
          <ion-ripple-effect></ion-ripple-effect>
        </button>
        <button class="btn-rotate btn-rotate_right ion-activatable" (click)="rotate('right')">
          <img [src]="IconRotate" />
          <ion-ripple-effect></ion-ripple-effect>
        </button>
      </div>
    }
  </div>

  <div class="cropper-modal__footer">
    <app-button
      [btnType]="Buttons.btnFilter"
      [textSize]="ButtonTextSizes.buttonText1"
      [isDisabled]="isLoading"
      (click)="closed()"
      class="cropper-modal__cancel"
      text="отмена"
    ></app-button>
    <app-button
      [btnType]="Buttons.base"
      [textSize]="ButtonTextSizes.buttonText1"
      [isDisabled]="isLoading || !croppedImage"
      (click)="onComplete()"
      text="загрузить"
    ></app-button>
  </div>
</div>
